module.exports = __webpack_public_path__ + "291d0fb654f2738012dabe35f370a1cd.svg";